module.exports = __webpack_public_path__ + "fonts/lato-v11-latin-regular.woff";


//////////////////
// WEBPACK FOOTER
// ./src/js/core/fonts/lato-v11-latin-regular.woff
// module id = 18
// module chunks = 0